import validateFrequencyStep from "state/validateFrequencyStep";

const validateStep = (step, state) => {
  switch (step) {
    case "frequency":
      return validateFrequencyStep(state.dirtyState);

    default:
      return true;
  }
};

export default validateStep;



// WEBPACK FOOTER //
// ./src/state/validateStep.js